export default __webpack_public_path__ + "static/media/59.1c212636.png";